import * as React from "react";
import { HomePageStyled } from "../home/styled";
import { Link, useNavigate } from "react-router-dom";
import { GroupLogo } from "../../components";
import { Typography } from "@mui/material";
import { Button, Image } from "react-bootstrap";
import {
  TUTORIALS_TILELIST,
  HOMEPAGE_CONSTANTS,
  HOMEPAGE_FOOTER_LINKS,
  FACEBOOK_LINK,
  LINKEDIN_LINK,
  INSTAGRAM_LINK,
} from "../../config/constants";
import {
  FacebookLogo,
  LinkedInLogo,
  InstagramLogo,
} from "../../assets/icons/index.js";
import { colors } from "../../config/colors.js";
import { ROUTES } from "../../config/routes";

const TutorialsPage = () => {
  const [hoveredItem, setIsHoveredItem] = React.useState("");
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HomePageStyled>
      <div className="home-container">
        <header className="home-header">
          <div>
            <div className="header-logo">
              <GroupLogo />
            </div>
          </div>
          <div className="flex-container">
            <Button
              onClick={() => navigate(ROUTES.HOME)}
              className="no-decoration"
              style={{ background: "none", border: "none", padding: 0 }}
            >
              <Typography component="h2" variant="h2">
                {HOMEPAGE_CONSTANTS.BACK_TO_HOME}
              </Typography>
            </Button>
          </div>
        </header>
        <div className="home-body">
          <div className="home-body-text">
            <Typography component="h1" variant="h1">
              Templates and Tutorials
            </Typography>
          </div>
        </div>
        <div className="home-tile-wrapper">
          {TUTORIALS_TILELIST.map((tile, idx) => {
            const handleMouseOver = () => {
              setIsHoveredItem(tile.image);
            };
            const handleMouseOut = () => {
              setIsHoveredItem("");
            };
            const isHovered = hoveredItem === tile.image;
            return (
              <Link
                key={tile.image + idx}
                className={
                  tile.isActive ? "home-tile-item" : "home-tile-item-disabled"
                }
                to={tile.isActive ? tile.link : false}
                target={tile.newTab ? "_blank" : "_self"}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                <Image
                  src={isHovered ? tile.activeImage : tile.image}
                  alt={tile.title}
                  loading="lazy"
                  width={tile.width || "140px"}
                  height="140px"
                  className="home-tile-image"
                />
                <div className="home-tile-header">{tile.title}</div>
                <div className="home-tile-body">{tile.body}</div>
              </Link>
            );
          })}
        </div>
        <div className="home-body">
          <div className="have-questions" id="contact-us">
            <Typography
              component="span"
              variant="h1"
              sx={{ color: colors.custom }}
            >
              {HOMEPAGE_CONSTANTS.HAVE_QUESTIONS}
            </Typography>
            <Typography
              component="span"
              variant="h1"
              sx={{ color: colors.primary }}
            >
              {HOMEPAGE_CONSTANTS.CONTACT_US}
            </Typography>
          </div>
        </div>
        <div className="home-footer-container">
          <GroupLogo bgColor={colors.custom} />
          <div className="home-footer">
            {HOMEPAGE_FOOTER_LINKS.map((link, idx) => (
              <a
                key={link.text + idx}
                href={link.link}
                target="_blank"
                className="no-decoration"
                rel="noreferrer"
              >
                <Typography component="div" variant="title2">
                  {link.text}
                </Typography>
              </a>
            ))}
          </div>
          <div className="home-footer-social">
            <Link
              to={FACEBOOK_LINK}
              target="_blank"
              rel="noreferrer"
              className="no-decoration"
            >
              <FacebookLogo />
            </Link>
            <Link
              to={LINKEDIN_LINK}
              target="_blank"
              rel="noreferrer"
              className="no-decoration"
            >
              <LinkedInLogo />
            </Link>
            <Link
              to={INSTAGRAM_LINK}
              target="_blank"
              rel="noreferrer"
              className="no-decoration"
            >
              <InstagramLogo />
            </Link>
          </div>
        </div>
        <div className="home-footer-bottom">
          <Typography component="p" variant="h3">
            {HOMEPAGE_CONSTANTS.COPYRIGHT}
          </Typography>
        </div>
      </div>
    </HomePageStyled>
  );
};

export default TutorialsPage;
